export const removeStyleAttributes = (html: string): string => {
  // Callers feed this the result of replaceLineBreak(t(...)), which passes empty
  // values straight through, so html is absent whenever the feature has no
  // description. Guarded the same way replaceLineBreak is.
  return html && html.replace(/\sstyle=(["']).*?\1/g, "")
}
